export default __webpack_public_path__ + "static/media/straight.d0f2b3ba.png";